<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Review Trace Elements
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('serum_sse') ? 'subsection-disabled' : ''">
          <u> Serum SSE </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'serum_sse')">
            <span class="glyphicon" :class="isRemovedSubsection('serum_sse') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <h4>
          <p>Spring SSE Your Farm(s) Average vs Regional Average</p>
          <p>NMOL/L</p>
        </h4>
        <box-plot-chart :chart-data="get_sse_data['data']" :options="get_sse_data['options']" ref="serum_sse_chart"/>

        <h4 :class="isRemovedSubsection('serum_sse_products') ? 'subsection-disabled' : ''">
          <u>SSE Products Purchased</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'serum_sse_products')">
            <span class="glyphicon" :class="isRemovedSubsection('serum_sse_products') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sseProduct, index) in model.CHARTS.serum_sse_products" :key="index"
              :class="getRowClass(model.CHARTS.serum_sse_products, 'Season', index)">

              <td class="text-left">{{ sseProduct["Season"] }}</td>
              <td class="text-left">{{ sseProduct["Product"] }}</td>
              <td class="text-left">{{ sseProduct["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('serum_mg') ? 'subsection-disabled' : ''">
          <u>Serum MG</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'serum_mg')">
            <span class="glyphicon" :class="isRemovedSubsection('serum_mg') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <h4>
          <p>Spring MG Your Farm(s) Average vs Regional Average</p>
          <p>MMOL/L</p>
        </h4>
        <box-plot-chart :chart-data="get_mg_data['data']" :options="get_mg_data['options']" ref="serum_mg_chart"/>

        <h4 :class="isRemovedSubsection('serum_mg_products') ? 'subsection-disabled' : ''">
          <u>MG Products Purchased</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'serum_mg_products')">
            <span class="glyphicon" :class="isRemovedSubsection('serum_mg_products') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mgProduct, index) in model.CHARTS.serum_mg_products" :key="index"
              :class="getRowClass(model.CHARTS.serum_mg_products, 'Season', index)">

              <td class="text-left">{{ mgProduct["Season"] }}</td>
              <td class="text-left">{{ mgProduct["Product"] }}</td>
              <td class="text-left">{{ mgProduct["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('liver_cu') ? 'subsection-disabled' : ''">
          <u>Liver CU</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'liver_cu')">
            <span class="glyphicon" :class="isRemovedSubsection('liver_cu') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <h4>
          <p>Spring LCU Your Farm(s) Average vs Regional Average</p>
          <p>MMOL/Kg</p>
        </h4>
        <box-plot-chart :chart-data="get_cu_data['data']" :options="get_cu_data['options']" ref="liver_cu_chart"/>

        <h4 :class="isRemovedSubsection('liver_cu_products') ? 'subsection-disabled' : ''">
          <u>CU Products Purchased</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'liver_cu_products')">
            <span class="glyphicon" :class="isRemovedSubsection('liver_cu_products') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cuProduct, index) in model.CHARTS.liver_cu_products" :key="index"
              :class="getRowClass(model.CHARTS.liver_cu_products, 'Season', index)">

              <td class="text-left">{{ cuProduct["Season"] }}</td>
              <td class="text-left">{{ cuProduct["Product"] }}</td>
              <td class="text-left">{{ cuProduct["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.trace_element_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.trace_element_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import BoxPlotChart from '../../charts/BoxPlotChart'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    BoxPlotChart,
  },
  data() {
    return {
      stepName: 'TraceElements',
    }
  },
  methods: {
    getLabels(data) {
      return data.map(row => row['Spring'])
    },
    getData(data, type) {
      if (type === 'farm') {
        return data.map(row => row['string_results'].split(', ').map(n => parseFloat(n)))
      } else if (type === 'region') {
        return data.map(row => row['reg_string_results'].split(', ').map(n => parseFloat(n)))
      }
    },
  },
  computed: {
    get_sse_data: function () {
      return {
        'data': {
          labels: this.getLabels(this.model.CHARTS.serum_sse),
          datasets: [
            {
              label: "Your Farm(s)",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(51, 122, 183, 0.6)",
              data: this.getData(this.model.CHARTS.serum_sse, 'farm'),
            },
            {
              label: "Region",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(255, 255, 0, 0.5)",
              data: this.getData(this.model.CHARTS.serum_sse, 'region'),
            },
          ]
        },
        'options': {
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.model.CHARTS.serum_sse[0]['Benchmark'],
              borderColor: 'red',
              borderWidth: 4,
              label: {
                enabled: false,
                content: 'Benchmark',
                backgroundColor: 'rgba(0,0,0,0.8)',
                position: 'right',
                yAdjust: -50,
                xAdjust: -50,
              }
            }],
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'NMOL/L'
              }
            }]
          }
        }
      }
    },
    get_mg_data : function () {
      return {
        'data': {
          labels: this.getLabels(this.model.CHARTS.serum_mg),
          datasets: [
            {
              label: "Your Farm(s)",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(51, 122, 183, 0.6)",
              data: this.getData(this.model.CHARTS.serum_mg, 'farm'),
            },
            {
              label: "Region",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(255, 255, 0, 0.5)",
              data: this.getData(this.model.CHARTS.serum_mg, 'region'),
            },
          ]
        },
        'options': {
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.model.CHARTS.serum_mg[0]['Benchmark'],
              borderColor: 'red',
              borderWidth: 4,
              label: {
                enabled: false,
                content: 'Benchmark'
              }
            }]
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'MMOL/L'
              }
            }]
          }
        }
      }
    },
    get_cu_data : function () {
      return {
        'data': {
          labels: this.getLabels(this.model.CHARTS.liver_cu),
          datasets: [
            {
              label: "Your Farm(s)",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(51, 122, 183, 0.6)",
              data: this.getData(this.model.CHARTS.liver_cu, 'farm'),
            },
            {
              label: "Region",
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, .4)',
              backgroundColor: "rgba(255, 255, 0, 0.5)",
              data: this.getData(this.model.CHARTS.liver_cu, 'region'),
            },
          ]
        },
        'options': {
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.model.CHARTS.liver_cu[0]['Benchmark'],
              borderColor: 'red',
              borderWidth: 4,
              label: {
                enabled: false,
                content: 'Benchmark'
              }
            }]
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'MMOL/Kg'
              }
            }]
          }
        }
      }
    },
  },
};
</script>
